import { PlatformService } from './platform-service';
import {
  NusoSipSettings,
  CloudUcSettings,
  BlueSipSettings,
  GreenUcSettings,
  IpFaxSettings,
  TeamsOcSettings,
  CcaasSettings,
  BridgeZoomSettings,
  RecordingServiceSettings,
  BridgeTeamsSettings,
  TeamsAdSettings,
  CarrierTrunkSettings,
  CarrierTenantTrunkSettings,
  GreenResellerSettings,
  WorkflowDemoSettings,
  TeamsDomainSettings,
  ZoomDomainSettings,
} from './platform-specific-settings';

export function getNusoSipServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as NusoSipSettings;
}

export function getCloudUcServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as CloudUcSettings;
}

export function getBlueSipServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as BlueSipSettings;
}

export function getGreenUcServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as GreenUcSettings;
}

export function getIpFaxServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as IpFaxSettings;
}

export function getTeamsOcServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as TeamsOcSettings;
}

export function getTeamsAdServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as TeamsAdSettings;
}

export function getCcaasServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as CcaasSettings;
}

export function getBridgeZoomServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as BridgeZoomSettings;
}

export type ZoomAllocatedProduct = 'ZOOM_PHONE' | 'ZOOM_CONTACT_CENTER';
export const ZOOM_ALLOCATED_PRODUCTS: ZoomAllocatedProduct[] = ['ZOOM_PHONE', 'ZOOM_CONTACT_CENTER'];
export const ZOOM_ALLOCATED_PRODUCT_LABELS: Record<ZoomAllocatedProduct, string> = {
  ZOOM_PHONE: 'Zoom Phone',
  ZOOM_CONTACT_CENTER: 'Zoom Contact Center',
};

// The single accessor for the bridge-zoom allocated product: every read goes
// through here, never through settings.allocatedProduct directly. Unknown
// values normalize to ZOOM_PHONE — write-side validation is the primary gate;
// this is defense in depth for values persisted by non-UI callers.
export function getZoomAllocatedProduct(service: PlatformService): ZoomAllocatedProduct {
  const value = getBridgeZoomServiceSettings(service)?.allocatedProduct;
  if (!value) {
    // absent or '' — '' would otherwise survive the ?? default and crash the trunk-matrix lookup
    return 'ZOOM_PHONE';
  }
  if (!ZOOM_ALLOCATED_PRODUCTS.includes(value)) {
    console.warn(`Unknown allocatedProduct '${value}' on service ${service.id}; treating as ZOOM_PHONE`);
    return 'ZOOM_PHONE';
  }
  return value;
}

export function getBridgeTeamsServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as BridgeTeamsSettings;
}

export function getCarrierTrunkServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as CarrierTrunkSettings;
}

export function getCarrierTenantTrunkServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as CarrierTenantTrunkSettings;
}

export function getGreenResellerServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as GreenResellerSettings;
}

export function getRecordingServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as RecordingServiceSettings;
}

export function getWorkflowDemoServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as WorkflowDemoSettings;
}

export function getTeamsDomainServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as TeamsDomainSettings;
}

export function getZoomDomainServiceSettings(service: PlatformService) {
  return service.settings.serviceSettings as ZoomDomainSettings;
}
